export default {
  BusinessPurchaseForecast: {
    ps1: '以下SKU已被禁用 :',
    ps2: '无法用于创建采购/销售订单',
    skuStatus: 'SKU状态',
    skuLabelList: 'SKU标签',
    suggestQty: '建议补货数量',
    toProdQty: '待生产数量',
    inProdQty: '在产商品数量',
    inTransitQty: '在途商品数量',
    onHandQty: '库存总量',
    actualProfitRate: '利润率',
    isSale: '是否继续在售',
    purchaseApply: '采购申请',
    createPurchaseApply: '创建采购申请单',
    isSuggest: '存在补货建议',
    msgError: '在系统中不存在!',
    ignore: '忽略',
    unIgnore: '解除忽略',
    ignoreReason: '忽略原因',
    title: '忽略预测',
    ignoreReview: '忽略审核',
    deadLine: '截止日期',
    isIgnore: '是否忽略',
    totalQty: '预测总量',
    inApprovalQty: '审批中数量',
    approvedQty: '已审批数量',
    schedulingQty: '已排单数量',
    shippingQty: '已出货数量',
    shipmentQty: '已装船数量',
    preOccupyQty: '占用数量',
    skuAvgDaySales: '日均销量',
    lowStockWater: '最低库存水位',
    priorityLevel: '返单优先级',
    endTime: '忽略截止日期',
    remark1: '审核备注',
    errorMsg: '所选数据存在已忽略数据，请重新选择！',
    month: '预计销售月数',
    level: '等级',
    erpRequestReturnDate: 'ERP要求返单日期',
    salesMonthsHistory: '历史数据',
    salesMonthsHistoryText1: '月份曲线',
    salesMonthsHistoryText2: '等级曲线',
    exportTitle: '采购预测',
    breakevenPrice: '保本价',
    marginPrice: '最低包邮价',
    deliveryTime: '预计到货时间',
    operationSuggestions: '操作建议',
    fast: '快销品',
    normal: '常规品',
    slow: '滞销品',
    levelFour: '库存回归看板',
    userManual: '用户手册',
    breakevenPriceTooltip: '该产品在保本的情况下建议售价(含邮费)',
    marginPriceTooltip: '该产品在有15%利润率的情况下建议售价(含邮费)',
    deliveryTimeTooltip: '该产品正在执行PO的预计到达仓库时间',
    operationSuggestionsTooltip: '系统推荐的当前最佳操作方案',
    salesMonthsHistoryTooltip1: '该产品等级在过去12周的变化曲线',
    salesMonthsHistoryTooltip2: '该产品预计销售月数在过去12周的变化曲线',

    userManualData: {
      p1: '库存预测报告里面所有数据每周一凌晨刷新一次。',
      p2: '产品等级评判标准为预测的可销售月份数。计算公式：',
      p21: '日均销量 = N1天日均销量 * N1天加权值 + N2天日均销量 * N2天加权值 + N3天日均销量 * N3天加权值 + ……；',
      p22: '日均数据和加权数据在业务中心——采购管理——基础配置中配置；',
      p23: '例如：日均销量=3天日均销量 * 10% + 7天日均销量 * 10% + 15天日均销量 * 15% + 30天日均销量 * 25% + 60天日均销量 * 20% + 90天日均销量 * 20%。',
      p24: '预计销售月数=((已装船数量 + 库存总量) / 日均销量) / 30天。',
      p3: '页面可以基于SKU名称进行模糊查找，可以基于等级进行刷选，可以把当前选中产品导出excel表格。',
      p4: '触发机制:',
      p41: '产品等级为快销品1,2,3的时候，会触发涨价建议。涨价标准为等级为1时涨25%，等级为2时涨10%，等级为3时涨5%。',
      p42: '产品等级为滞销品5,6,7的时候，会触发降价建议。降价标准为连续两周等级不变或者呈现下滑趋势，则依据当前周的等级为5时降5%，等级为6时降10%，等级为7时降15%。',
      p43: '出现在库存回归看板中的产品，当前售价建议调整回正常销售价格。',
      p5: '特殊处理：',
      p51: '连续6周等级为5,6,7。而且当前周的等级大于等于6周前的等级，则建议 offer to idropship。',
      p52: '连续10周等级为5,6,7。而且当前周的等级大于等于10周前的等级，则建议 offer to mydeal or temple。'
    },
    suggestQtyTooltip: '预测总量-已备货数量',
    totalQtyTooltip: '订单周期内需要备货数量',
    inApprovalQtyTooltip: 'ERP采购申请单中待审批SKU数量',
    approvedQtyTooltip1: '已在ERP采购单中，但未生成采购合同的SKU数量；已审批数量=ERP中未执行的采购单中SKU数量-富通中对应采购合同中SKU数量；',
    schedulingQtyTooltip: '在采购合同中且未生成出运单的SKU数量；已排单数量=富通中未执行采购合同中SKU数量-富通中对应出运单中SKU数量；',
    shippingQtyTooltip: '在开船日期为空的出运单中且出运单未抵达出运国家的SKU数量',
    shipmentQtyTooltip: '在开船日期不为空的出运单中且出运单未抵达出运国家的SKU数量',
    onHandQtyTooltip: 'SAP中SKU库存数量',
    preOccupyQtyTooltip: '预售或超卖订单中SKU数量',
    priorityLevelTooltip1: 'ABC三级：A级：所有正利润SKU中，占销售额前80%的SKU记为A级；B级：剩余20%的SKU中利润率大于15%的记为B级；C级：其他SKU；',
    erpRequestReturnDateTooltip1: 'A级：5个工作日；B级：12个工作日；C级：无要求；工作日为中国法定节假日外的日期；',
    forecastUserManualData: {
      p1: '采购预测里面所有数据每周一凌晨刷新一次。',
      p2: '页面可以基于SKU名称进行模糊查找，可以基于等级进行刷选，可以筛查存在补货建议的SKU，可以把当前选中产品导出excel表格。',
      p3: '各字段含义或数据来源：',
      p301: '建议补货数量：预测总量-已备货数量；',
      p302: '预测总量：订单周期内需要备货数量；',
      p303: '已备货数量：审批中数量+已审批数量+已排单数量+已出货数量+已装船数量+库存总量-占用数量；',
      p304: '审批中数量：ERP采购申请单中待审批SKU数量；',
      p305: '已审批数量：已在ERP采购单中，但未生成采购合同的SKU数量；已审批数量=ERP中未执行的采购单中SKU数量-富通中对应采购合同中SKU数量；',
      p306: '已排单数量：在采购合同中且未生成出运单的SKU数量；已排单数量=富通中未执行采购合同中SKU数量-富通中对应出运单中SKU数量；',
      p307: '已出货数量：在开船日期为空的出运单中且出运单未抵达出运国家的SKU数量；',
      p308: '已装船数量：在开船日期不为空的出运单中且出运单未抵达出运国家的SKU数量；',
      p309: '库存总量：SAP中SKU库存数量；',
      p310: '占用数量：预售或超卖订单中SKU数量；',
      p311: '交货周期：从采购申请到运达目的地的时间，单位：天；',
      p312: '订单周期：从采购到售出的时间，单位：天；',
      p313: '返单优先级：ABC三级，A级：所有正利润SKU中，占销售额前80%的SKU记为A级；B级：剩余20%的SKU中利润率大于15%的记为B级；C级：其他SKU；',
      p314: 'ERP要求返单日期：A级：5个工作日；B级：5个工作日；C级：无要求；工作日为中国法定节假日外的日期；',
      p4: '基础数据配置：',
      p41: '业务中心-采购管理-基础配置；',
      p42: '预测日期权重：用于计算日均销量；',
      p43: '预测日期：用于计算日均销量；',
      p44: '最小建议数量：用于判断是否建议补货；',
      p45: '订单周期：用于计算预测总量；',
      p46: '交货周期：用于计算最低库存水位；',
      p5: '不可配置的基础数据：',
      p51: '置信区间=2.05；',
      p52: '季度权重；',
      p53: '1，2，3三个月的权重是 90.69%；',
      p54: '4，5，6三个月的权重是91.61%；',
      p55: '7，8，9三个月的权重是112.06%；',
      p56: '10，11，12三个月的权重是106.27%；',
      p6: '业务逻辑：',
      p601: '日均销量：',
      p602: '日均销量 = N1天日均销量 * N1天加权值 + N2天日均销量 * N2天加权值 + N3天日均销量 * N3天加权值 + ……；',
      p603: '例如：',
      p604: '预测日期权重：10-10-15-25-20-20，该数据在业务中心-采购管理-基础配置管理；',
      p605: '预测日期：3-7-14-30-60-90，该数据在业务中心-采购管理-基础配置管理；',
      p606: '日均销量=3天日均销量 * 10% + 7天日均销量 * 10% + 15天日均销量 * 15% + 30天日均销量 * 25% + 60天日均销量 * 20% + 90天日均销量 * 20%',
      p607: '安全库存：',
      p608: '安全库存=sqrt(交货周期)x置信区间x标准差；',
      p609: '置信区间=2.05，固定值；',
      p610: '标准差 ≈ 0.7~1.3倍日均销量，具体计算方式如下:',
      p611: '交货周期 = N. 该数据在业务中心-采购管理-基础配置管理，需要可以修改；',
      p612: '此处的截取范围：不算预测当日，向前截取N日，不要跳过一日的任何销量，完全截取N天，包括销量为0等所有情况；',
      p613: '交货周期平均销量 M = （第1天销量 + 第2天销量 + ….. + 第N天销量）/N；',
      p614: '标准差= sqrt(((第1天销量-M)^2 +(第2天销量-M)^2 +......(第N天销量-M)^2)/（N -1）)；',
      p616: '最低库存水位：',
      p617: '最低库存水位=安全库存+日均销量*交货周期；',
      p618: '建议补货数量：',
      p619: '如果 已备货数量 > 最低库存水位，则 库存充足，建议补货数量为0；',
      p620: '如果 已备货数量 <= 最低库存水位，则 库存不足，需要计算建议补货数量；',
      p621: '建议补货数量=预测总量-已备货数量；',
      p622: '预测总量=（日均销量x 订单周期 +安全库存）*季度权重；',
      p623: '订单周期：该数据在业务中心-采购管理-基础配置管理；',
      p624: '是否存在补货建议:',
      p625: '存在补货建议需要满足以下条件：',
      p626: '建议补货数量 > 最小建议数量;最小建议数量:该数据在业务中心-采购管理-基础配置管理；',
      p627: 'SKU未被忽略；',
      p628: '不存在21天以内的采购申请单；',
      p629: '是否忽略：',
      p630: '填写忽略截止日期，发起忽略申请；如果发起人有审批权限，则自动审批通过；',
      p631: '审批人同意或拒绝申请；',
      p632: '同意忽略的SKU，在忽略截止日期之前，存在补货建议均为否；',
    }
  }
};
